import { MessageCircle, Puzzle, Brain, Baby, Users, Utensils, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Heart, Star, Flower, Squiggle, Smiley, SpiralCircle, Cloud } from "./Illustrations";

const services = [
  {
    id: "logo",
    slug: "logotherapeia",
    title: "Λογοθεραπεία",
    desc: "Αξιολόγηση και θεραπεία διαταραχών λόγου, ομιλίας, φωνής και επικοινωνίας σε παιδιά και εφήβους.",
    icon: MessageCircle,
    bgColor: "bg-brand-pinkSoft",
    accentColor: "bg-brand-pink",
    rotate: "-rotate-1",
    span: "lg:col-span-4",
  },
  {
    id: "ergo",
    slug: "ergotherapeia",
    title: "Εργοθεραπεία",
    desc: "Ενίσχυση δεξιοτήτων αυτοεξυπηρέτησης, λεπτής & αδρής κινητικότητας και αισθητηριακής ολοκλήρωσης.",
    icon: Puzzle,
    bgColor: "bg-brand-yellowSoft",
    accentColor: "bg-brand-yellow",
    rotate: "rotate-1",
    rooms: [
      {
        title: "Αίθουσα SI — Αισθητηριακής Ολοκλήρωσης",
        desc: "Ειδικά διαμορφωμένος θεραπευτικός χώρος Αισθητηριακής Ολοκλήρωσης. Στόχος της είναι να βοηθήσει τα παιδιά να επεξεργάζονται και να οργανώνουν τα ερεθίσματα που δέχονται από το περιβάλλον μέσω των αισθήσεών τους.",
      },
      {
        title: "Αίθουσα Snoezelen",
        desc: "Ειδικά σχεδιασμένος χώρος όπου ελεγχόμενα πολυαισθητηριακά ερεθίσματα συνδυάζονται για να δημιουργήσουν ένα ιδιαίτερο και ελεγχόμενο αισθητηριακό περιβάλλον — με στόχο τη διέγερση ή τη χαλάρωση των αισθήσεων. Βοηθά στη χαλάρωση, τη μείωση του άγχους και την ανάπτυξη της επικοινωνίας.",
      },
    ],
    span: "lg:col-span-4",
    highlight: true,
  },
  {
    id: "psi",
    slug: "psychologiki-ypostirixi",
    title: "Ψυχολογική Υποστήριξη",
    desc: "Συμβουλευτική και ψυχοθεραπεία παιδιών & εφήβων σε ένα ασφαλές, υποστηρικτικό πλαίσιο.",
    icon: Brain,
    bgColor: "bg-brand-blueSoft",
    accentColor: "bg-brand-blue",
    rotate: "-rotate-1",
    span: "lg:col-span-4",
  },
  {
    id: "early",
    slug: "proimi-paremvasi",
    title: "Πρώιμη Παρέμβαση",
    desc: "Ολοκληρωμένο πρόγραμμα για μικρά παιδιά έως νήπια με αναπτυξιακές δυσκολίες, σε συνεργασία με την οικογένεια.",
    icon: Baby,
    bgColor: "bg-brand-secondarySoft",
    accentColor: "bg-brand-secondary",
    rotate: "rotate-1",
    span: "lg:col-span-4",
  },
  {
    id: "parents",
    slug: "symvouleftiki-goneon",
    title: "Συμβουλευτική Γονέων",
    desc: "Ατομικές και ομαδικές συναντήσεις για την υποστήριξη του γονεϊκού ρόλου και την ενδυνάμωση της οικογένειας.",
    icon: Users,
    bgColor: "bg-brand-purpleSoft",
    accentColor: "bg-brand-purple",
    rotate: "-rotate-1",
    span: "lg:col-span-4",
  },
  {
    id: "sitisi",
    slug: "therapeia-sitisis",
    title: "Θεραπεία Σίτισης",
    desc: "Θεραπεία σίτισης παιδιών και εφήβων με τροφική επιλεκτικότητα.",
    icon: Utensils,
    bgColor: "bg-brand-pinkSoft",
    accentColor: "bg-brand-pink",
    rotate: "rotate-1",
    span: "lg:col-span-4",
  },
];

export default function Services() {
  return (
    <section
      id="ypiresies"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-brand-cream overflow-hidden"
    >
      <Cloud className="absolute top-12 right-12 opacity-90 hidden md:block" size={90} />
      <Cloud className="absolute top-32 left-8 opacity-80 hidden lg:block" size={70} />
      <Flower className="absolute top-1/2 right-8 animate-wiggle hidden lg:block" size={60} color="#B8D6E8" />
      <Star className="absolute bottom-20 right-1/4 animate-pulse-soft" size={26} color="#FBE4A8" />
      <SpiralCircle className="absolute bottom-12 left-12 animate-spin-slow hidden md:block" size={80} color="#D9C7EC" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white border-2 border-brand-pink mb-6 rotate-1">
            <Heart size={18} color="#F4A899" />
            <span className="font-body text-sm font-bold text-brand-text">
              Οι Υπηρεσίες μας
            </span>
          </div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-brand-text leading-tight">
            Εξειδικευμένη φροντίδα,<br />
            <span className="font-hand text-5xl sm:text-6xl lg:text-7xl text-brand-primary">
              για κάθε παιδί
            </span>
          </h2>
          <Squiggle className="mx-auto my-6" width={180} color="#FBE4A8" />
          <p className="font-body text-base sm:text-lg text-brand-textSoft leading-relaxed">
            Παρέχουμε ένα ευρύ φάσμα ειδικών θεραπειών, σχεδιασμένων να καλύπτουν
            τις μοναδικές ανάγκες κάθε παιδιού και της οικογένειάς του.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
          {services.map((service) => {
            const Icon = service.icon;
            return (
              <article
                key={service.id}
                data-testid={`service-card-${service.id}`}
                className={`group relative ${service.span} ${service.rotate} hover:rotate-0 transition-transform duration-500 rounded-[2rem] ${service.bgColor} border-3 border-dashed border-brand-text/15 p-7 md:p-8 hover:scale-[1.02] shadow-[0_8px_0_-2px_rgba(91,79,70,0.15)]`}
              >
                {service.highlight && (
                  <div className="absolute -top-3 -right-3 px-4 py-1.5 rounded-full bg-brand-primary text-white text-xs font-bold rotate-12 shadow-[0_3px_0_#5B4F46] border-2 border-brand-text/20">
                    Νέες Αίθουσες! ✨
                  </div>
                )}

                <div className="flex items-start gap-4 mb-4">
                  <div className={`w-16 h-16 rounded-2xl ${service.accentColor} flex items-center justify-center flex-shrink-0 border-2 border-brand-text/20 -rotate-6 group-hover:rotate-0 transition-transform`}>
                    <Icon className="text-brand-text" size={28} strokeWidth={2.2} />
                  </div>
                  <div className="flex-1 pt-2">
                    <h3 className="font-heading font-bold text-2xl text-brand-text leading-tight">
                      {service.title}
                    </h3>
                  </div>
                </div>

                {service.desc && (
                  <p className="font-body text-brand-textSoft leading-relaxed text-[15px] mb-4">
                    {service.desc}
                  </p>
                )}

                {service.rooms && (
                  <div className="space-y-3 mt-5">
                    {service.rooms.map((room, idx) => (
                      <div
                        key={idx}
                        data-testid={`service-${service.id}-room-${idx}`}
                        className="p-4 rounded-2xl bg-white border-2 border-dashed border-brand-text/15"
                      >
                        <div className="flex items-center gap-2 mb-2">
                          <Star size={18} color="#F4A899" />
                          <div className="font-heading font-bold text-brand-text text-sm">
                            {room.title}
                          </div>
                        </div>
                        <p className="font-body text-xs text-brand-textSoft leading-relaxed">
                          {room.desc}
                        </p>
                      </div>
                    ))}
                  </div>
                )}

                <Link
                  to={`/${service.slug}`}
                  data-testid={`service-link-${service.id}`}
                  className="inline-flex items-center gap-1.5 mt-2 font-heading font-bold text-sm text-brand-primaryHover hover:gap-2.5 transition-all"
                >
                  Μάθετε περισσότερα
                  <ArrowRight size={16} strokeWidth={2.5} />
                </Link>

                <Heart className="absolute bottom-4 right-4 opacity-40 group-hover:opacity-100 transition-opacity" size={22} color="#F4A899" />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
